import { SourcingEventRow } from './useRfxColumns'

const UPCOMING_LIMIT = 4

const dueTime = ({ dueDate }: SourcingEventRow) => (dueDate ? Date.parse(dueDate) : Number.MAX_SAFE_INTEGER)

const isOpen = (row: SourcingEventRow) => row.kind === 'AUCTION' || row.status !== 'COMPLETE'

export const selectUpcomingSourcingEvents = (rows: SourcingEventRow[]): SourcingEventRow[] =>
  rows
    .filter(isOpen)
    .sort((a, b) => dueTime(a) - dueTime(b))
    .slice(0, UPCOMING_LIMIT)
